
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vvxn7_1gw9p_99",
  "grid": "awsui_grid_vvxn7_1gw9p_134",
  "grid-no-gutters": "awsui_grid-no-gutters_vvxn7_1gw9p_140",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vvxn7_1gw9p_144",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vvxn7_1gw9p_152",
  "grid-columns-1": "awsui_grid-columns-1_vvxn7_1gw9p_155",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vvxn7_1gw9p_155",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vvxn7_1gw9p_158",
  "grid-columns-2": "awsui_grid-columns-2_vvxn7_1gw9p_161",
  "grid-columns-3": "awsui_grid-columns-3_vvxn7_1gw9p_167",
  "grid-columns-4": "awsui_grid-columns-4_vvxn7_1gw9p_173",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vvxn7_1gw9p_189",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vvxn7_1gw9p_222"
};
  